export const fixLinksHandle = (iframe: HTMLIFrameElement | null) => {
  if (!iframe) return
  // NOTE: set target="_parent" to have ability open the link in the same tab
  const iframeDocument = iframe.contentDocument
  if (iframeDocument) {
    const links = Array.from(iframeDocument.querySelectorAll('a'))
    links.forEach(link => {
      if (link.getAttribute('target') !== '_blank') {
        link.setAttribute('target', '_parent')
      }
    })
  }
}

export const resizeOnLoad = (iframe: HTMLIFrameElement) => {
  const height = iframe.contentWindow?.document.body.scrollHeight
  iframe.style.height = height ? `${height}px` : '100%'
  return height
}
